import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

const Options = styled.div`
  padding: 18px 8px;
  min-width: 116px;
  width: ${prop('width')};
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
`;

const Option = styled.div`
  position: relative;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;

  cursor: pointer;
  color: rgba(0, 0, 0, 0.5);
  :after {
    position: absolute;
    content: '';
    height: 1px;
    width: 100%;
    background: #173051;
    border-radius: 1px;
    opacity: 50%;
    left: 0;
    bottom: -7px;
  }

  :last-child {
    margin-bottom: 0;
    :after {
      content: none;
    }
  }
`;

const Flag = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 8px;
  margin-left: 2px;
  border-radius: 100%;
`;

const Trigger = styled.div`
  display: flex;
  align-items: center;
`;

const TriggerIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid #173051;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
`;

const TriggerIcon = styled.img`
  width: 14px;
  height: 14px;
  border-radius: 100%;
`;

const TriggerText = styled.div`
  // color: ${(props) => props.theme.sizing.menuPadding};
  color: black;
  margin-right: 7px;
`;

const TriggerArrow = styled.img`
  transform-origin: center;
  transform: ${ifProp(
    'open',
    css`
    rotate(0deg)
  `,
    css`
    rotate(180deg)
  `
  )};
`;

export {
  Options,
  Option,
  Flag,
  Trigger,
  TriggerIcon,
  TriggerIconWrapper,
  TriggerText,
  TriggerArrow,
};
